import React from "react";
import EmptyState from "../empty-state";
import Loading from "../loading";
import StatusState from "../status-state";

const isCollectionEmpty = (value) => {
  if (value == null) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  return false;
};

const resolveErrorStatus = (error) => {
  const responseStatus = error?.response?.status;

  if ([400, 401, 500].includes(responseStatus)) {
    return responseStatus;
  }

  return 500;
};

const QueryState = ({
  data,
  isLoading,
  error,
  empty,
  emptyProps,
  errorProps,
  children,
}) => {
  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    const status = resolveErrorStatus(error);

    return <StatusState status={status} {...errorProps} />;
  }

  const hasNoData = typeof empty === "boolean" ? empty : isCollectionEmpty(data);

  if (hasNoData) {
    return <EmptyState {...emptyProps} />;
  }

  return typeof children === "function" ? children(data) : children;
};

export default QueryState;
